
import { useNavigate } from "react-router-dom";

const handleUnauthorizedUser = () => {
  const navigate = useNavigate();
  const role = localStorage.getItem("role");
  // Managers get team-scoped access to the same succession pages as HR, so they
  // must not be bounced to /profile here.
  const persona = localStorage.getItem("persona");
  const unAuthorizeUser = () => {
    // Managers get team-scoped access to these pages — never bounce them, even
    // when they have no HR/spotlight role (role stored as the string "undefined").
    if (persona === "manager") return;
    if (role && role === "undefined") {
      navigate("/profile");
    } else if (role && !role.includes("hr")) {
      navigate("/profile");
    }
  };

  return {unAuthorizeUser};
};

export default handleUnauthorizedUser;
